var _rect, _path, _path2, _path3, _mask, _path4, _mask2, _path5, _mask3, _path6, _mask4, _path7, _mask5, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoftEnggLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1183,
    height: 504,
    viewBox: "0 0 1183 504",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 414.627,
    y: 63,
    width: 440.87,
    height: 441,
    rx: 75,
    fill: "url(#paint0_linear_1_48)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.795 380.1H272.394L321.205 254.1L362.143 254.1",
    stroke: "url(#paint1_linear_1_48)",
    strokeWidth: 25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.295 88.2H187.894L236.705 190.575H356.369",
    stroke: "url(#paint2_linear_1_48)",
    strokeWidth: 25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M797.764 325.5H884.363L949.969 216.3H1080.13",
    stroke: "url(#paint3_linear_1_48)",
    strokeWidth: 25
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_1_48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.969 86.1C104.969 115.095 81.4708 138.6 52.4845 138.6C23.4981 138.6 0 115.095 0 86.1C0 57.1051 23.4981 33.6 52.4845 33.6C81.4708 33.6 104.969 57.1051 104.969 86.1ZM20.9938 86.1C20.9938 103.497 35.0926 117.6 52.4845 117.6C69.8763 117.6 83.9752 103.497 83.9752 86.1C83.9752 68.703 69.8763 54.6 52.4845 54.6C35.0926 54.6 20.9938 68.703 20.9938 86.1Z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.969 86.1C104.969 115.095 81.4708 138.6 52.4845 138.6C23.4981 138.6 0 115.095 0 86.1C0 57.1051 23.4981 33.6 52.4845 33.6C81.4708 33.6 104.969 57.1051 104.969 86.1ZM20.9938 86.1C20.9938 103.497 35.0926 117.6 52.4845 117.6C69.8763 117.6 83.9752 103.497 83.9752 86.1C83.9752 68.703 69.8763 54.6 52.4845 54.6C35.0926 54.6 20.9938 68.703 20.9938 86.1Z",
    fill: "url(#paint4_linear_1_48)",
    stroke: "url(#paint5_linear_1_48)",
    strokeWidth: 50,
    mask: "url(#path-5-inside-1_1_48)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-2_1_48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1183 217.35C1183 246.345 1159.5 269.85 1130.52 269.85C1101.53 269.85 1078.03 246.345 1078.03 217.35C1078.03 188.355 1101.53 164.85 1130.52 164.85C1159.5 164.85 1183 188.355 1183 217.35ZM1099.02 217.35C1099.02 234.747 1113.12 248.85 1130.52 248.85C1147.91 248.85 1162.01 234.747 1162.01 217.35C1162.01 199.953 1147.91 185.85 1130.52 185.85C1113.12 185.85 1099.02 199.953 1099.02 217.35Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1183 217.35C1183 246.345 1159.5 269.85 1130.52 269.85C1101.53 269.85 1078.03 246.345 1078.03 217.35C1078.03 188.355 1101.53 164.85 1130.52 164.85C1159.5 164.85 1183 188.355 1183 217.35ZM1099.02 217.35C1099.02 234.747 1113.12 248.85 1130.52 248.85C1147.91 248.85 1162.01 234.747 1162.01 217.35C1162.01 199.953 1147.91 185.85 1130.52 185.85C1113.12 185.85 1099.02 199.953 1099.02 217.35Z",
    fill: "url(#paint6_linear_1_48)",
    stroke: "url(#paint7_linear_1_48)",
    strokeWidth: 50,
    mask: "url(#path-6-inside-2_1_48)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-3_1_48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1078.03 348.6C1078.03 377.595 1054.53 401.1 1025.55 401.1C996.56 401.1 973.062 377.595 973.062 348.6C973.062 319.605 996.56 296.1 1025.55 296.1C1054.53 296.1 1078.03 319.605 1078.03 348.6ZM994.056 348.6C994.056 365.997 1008.15 380.1 1025.55 380.1C1042.94 380.1 1057.04 365.997 1057.04 348.6C1057.04 331.203 1042.94 317.1 1025.55 317.1C1008.15 317.1 994.056 331.203 994.056 348.6Z"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.03 348.6C1078.03 377.595 1054.53 401.1 1025.55 401.1C996.56 401.1 973.062 377.595 973.062 348.6C973.062 319.605 996.56 296.1 1025.55 296.1C1054.53 296.1 1078.03 319.605 1078.03 348.6ZM994.056 348.6C994.056 365.997 1008.15 380.1 1025.55 380.1C1042.94 380.1 1057.04 365.997 1057.04 348.6C1057.04 331.203 1042.94 317.1 1025.55 317.1C1008.15 317.1 994.056 331.203 994.056 348.6Z",
    fill: "url(#paint8_linear_1_48)",
    stroke: "url(#paint9_linear_1_48)",
    strokeWidth: 50,
    mask: "url(#path-7-inside-3_1_48)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-4_1_48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M973.062 112.35C973.062 141.345 949.564 164.85 920.578 164.85C891.591 164.85 868.093 141.345 868.093 112.35C868.093 83.3551 891.591 59.85 920.578 59.85C949.564 59.85 973.062 83.3551 973.062 112.35ZM889.087 112.35C889.087 129.747 903.186 143.85 920.578 143.85C937.97 143.85 952.068 129.747 952.068 112.35C952.068 94.953 937.97 80.85 920.578 80.85C903.186 80.85 889.087 94.953 889.087 112.35Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M973.062 112.35C973.062 141.345 949.564 164.85 920.578 164.85C891.591 164.85 868.093 141.345 868.093 112.35C868.093 83.3551 891.591 59.85 920.578 59.85C949.564 59.85 973.062 83.3551 973.062 112.35ZM889.087 112.35C889.087 129.747 903.186 143.85 920.578 143.85C937.97 143.85 952.068 129.747 952.068 112.35C952.068 94.953 937.97 80.85 920.578 80.85C903.186 80.85 889.087 94.953 889.087 112.35Z",
    fill: "url(#paint10_linear_1_48)",
    stroke: "url(#paint11_linear_1_48)",
    strokeWidth: 50,
    mask: "url(#path-8-inside-4_1_48)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-5_1_48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.795 380.1C185.795 409.095 162.297 432.6 133.311 432.6C104.324 432.6 80.8262 409.095 80.8262 380.1C80.8262 351.105 104.324 327.6 133.311 327.6C162.297 327.6 185.795 351.105 185.795 380.1ZM101.82 380.1C101.82 397.497 115.919 411.6 133.311 411.6C150.702 411.6 164.801 397.497 164.801 380.1C164.801 362.703 150.702 348.6 133.311 348.6C115.919 348.6 101.82 362.703 101.82 380.1Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.795 380.1C185.795 409.095 162.297 432.6 133.311 432.6C104.324 432.6 80.8262 409.095 80.8262 380.1C80.8262 351.105 104.324 327.6 133.311 327.6C162.297 327.6 185.795 351.105 185.795 380.1ZM101.82 380.1C101.82 397.497 115.919 411.6 133.311 411.6C150.702 411.6 164.801 397.497 164.801 380.1C164.801 362.703 150.702 348.6 133.311 348.6C115.919 348.6 101.82 362.703 101.82 380.1Z",
    fill: "url(#paint12_linear_1_48)",
    stroke: "url(#paint13_linear_1_48)",
    strokeWidth: 50,
    mask: "url(#path-9-inside-5_1_48)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.895 75C356.895 33.5786 390.473 0 431.895 0H722.764C764.185 0 797.764 33.5786 797.764 75V366C797.764 407.421 764.185 441 722.764 441H703.292V309.447C724.586 302.757 740.031 282.858 740.031 259.35C740.031 230.355 716.533 206.85 687.547 206.85C658.56 206.85 635.062 230.355 635.062 259.35C635.062 282.858 650.508 302.757 671.801 309.447V441H598.323V150.897C619.617 144.207 635.062 124.308 635.062 100.8C635.062 71.805 611.564 48.3 582.578 48.3C553.591 48.3 530.093 71.805 530.093 100.8C530.093 124.308 545.539 144.207 566.832 150.897V441H481.808V244.347C503.101 237.657 518.547 217.758 518.547 194.25C518.547 165.255 495.049 141.75 466.062 141.75C437.076 141.75 413.578 165.255 413.578 194.25C413.578 217.758 429.023 237.657 450.317 244.347V441H431.895C390.473 441 356.895 407.421 356.895 366V75Z",
    fill: "url(#paint14_linear_1_48)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_48",
    x1: 414.627,
    y1: 63,
    x2: 855.627,
    y2: 503.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01FFA4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF06",
    stopOpacity: 0.49
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_48",
    x1: 273.969,
    y1: 380.1,
    x2: 273.969,
    y2: 254.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_48",
    x1: 228.832,
    y1: 88.2,
    x2: 228.832,
    y2: 190.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_48",
    x1: 938.947,
    y1: 216.3,
    x2: 938.947,
    y2: 325.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_48",
    x1: -1.8628,
    y1: 31.9421,
    x2: 117.412,
    y2: 45.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_48",
    x1: 52.4845,
    y1: 33.6,
    x2: 52.4845,
    y2: 138.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_48",
    x1: 1076.17,
    y1: 163.192,
    x2: 1195.44,
    y2: 176.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_48",
    x1: 1130.52,
    y1: 164.85,
    x2: 1130.52,
    y2: 269.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_48",
    x1: 971.199,
    y1: 294.442,
    x2: 1090.47,
    y2: 307.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_48",
    x1: 1025.55,
    y1: 296.1,
    x2: 1025.55,
    y2: 401.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_48",
    x1: 866.23,
    y1: 58.1921,
    x2: 985.505,
    y2: 71.6972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_48",
    x1: 920.578,
    y1: 59.85,
    x2: 920.578,
    y2: 164.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_48",
    x1: 78.9634,
    y1: 325.942,
    x2: 198.238,
    y2: 339.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B2FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_48",
    x1: 133.311,
    y1: 327.6,
    x2: 133.311,
    y2: 432.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FF29"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_48",
    x1: 356.895,
    y1: 0,
    x2: 797.895,
    y2: 440.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01FFA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEFF06"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftEnggLogo);
export default __webpack_public_path__ + "static/media/soft-engg-logo.4f0a1252f9a068ed4274ef8df90ea8b1.svg";
export { ForwardRef as ReactComponent };